import { useEffect } from 'react';

export const SecurityHeaders: React.FC = () => {
  useEffect(() => {
    // Set security headers via meta tags where possible
    const addMetaTag = (name: string, content: string) => {
      if (typeof document === 'undefined') return;
      
      let meta = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement;
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = name;
        document.head.appendChild(meta);
      }
      meta.content = content;
    };

    // Strict Content Security Policy (PostHog domains removed)
    addMetaTag('Content-Security-Policy', 
      "default-src 'self'; " +
      "script-src 'self' 'nonce-'; " +
      "style-src 'self' 'nonce-' https://fonts.googleapis.com; " +
      "font-src 'self' https://fonts.gstatic.com; " +
      "img-src 'self' data: https://*.supabase.co; " +
      "connect-src 'self' https://*.supabase.co https://api.activecampaign.com; " +
      "frame-ancestors 'none'; " +
      "base-uri 'self'; " +
      "form-action 'self';"
    );

    // X-Frame-Options equivalent
    addMetaTag('frame-options', 'DENY');
    
    // X-Content-Type-Options equivalent
    addMetaTag('content-type-options', 'nosniff');
    
    // Referrer Policy
    addMetaTag('referrer', 'strict-origin-when-cross-origin');

  }, []);

  return null;
};